import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { TermsComponent } from './components/terms/terms.component';
import { LanguageComponent } from './components/language/language.component';
import { PlayerComponent } from './components/player/player.component';
import { Player2Component } from './components/player2/player2.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SuccessComponent } from './components/success/success.component';
import { FailureComponent } from './components/failure/failure.component';

import { AuthGuard } from './guards/auth.guard';
import { TutorialComponent } from './components/tutorial/tutorial.component';
import { TestPlayerComponent } from './components/test-player/test-player.component';
import { PlayerappComponent } from './components/playerapp/playerapp.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { FaqComponent } from './components/faq/faq.component';
import { AppLandingComponent } from './components/app-landing/app-landing.component';

const APP_ROUTES: Routes = [
    { path: 'vimeo/player/test/:vimeo_id', component: TestPlayerComponent, canActivate: [AuthGuard] },
    //{ path: 'player/:mlb_id', component: PlayerComponent, canActivate: [AuthGuard] },
    { path: 'player-test-somos', component: PlayerComponent, canActivate: [AuthGuard], data: {testing: true} },
    { path: 'playerapp/:mlb_id', component: PlayerappComponent },
    { path: 'affiliate/:affiliate_id', component: HomeComponent },
    { path: 'checkout/validate', component: SuccessComponent, canActivate: [AuthGuard] },
    { path: 'checkout/failure', component: FailureComponent, canActivate: [AuthGuard] },
    { path: 'checkout/success', component: SuccessComponent, canActivate: [AuthGuard] },
    { path: 'checkout/:membership_id', component: CheckoutComponent, canActivate: [AuthGuard] },
    { path: 'player/chromecast/test', component: Player2Component },
    { path: 'language', component: LanguageComponent },
    { path: 'terms', component: TermsComponent },
    { path: 'privacy', component: PrivacyComponent },
    { path: 'tutorial', component: TutorialComponent },
    { path: 'home/:', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'profile', component: ProfileComponent },
    //{ path: 'calendar', component: CalendarComponent },
    { path: 'faqs', component: FaqComponent },
    { path: 'getApp', component: AppLandingComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'home' }
];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
